import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  SolarHdmDto,
  SolarHdmQuoteDraftDto,
  SolarHdmQuoteDto,
} from "../dto/solar-proposal-hdm.dto"
import { solarProposalService } from "../services/solar-proposal.service"

export type CreateSolarHdmQuoteVariables = {
  proposalId: string
  draft: SolarHdmQuoteDraftDto
}

/**
 * Creates an HDM quote from the confirmed details. The new quote joins the
 * HDM read's list in place, so the draft the seller edited isn't re-read.
 */
export default function useCreateSolarHdmQuote(): UseMutationResult<
  SolarHdmQuoteDto,
  unknown,
  CreateSolarHdmQuoteVariables
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, draft }: CreateSolarHdmQuoteVariables) =>
      solarProposalService.createHdmQuote(proposalId, {
        draft,
        confirmed: true,
      }),
    onSuccess: (quote, { proposalId }) => {
      queryClient.setQueryData<SolarHdmDto>(
        queryKeys.solarProposal.hdm(proposalId),
        (current) =>
          current ? { ...current, quotes: [quote, ...current.quotes] } : current,
      )
    },
  })
}
